import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConsultaInspeccionesComponent } from './consulta-inspecciones/consulta-inspecciones.component';
import { HomeComponent } from './home/home.component';
import { GrupoTipoComponent } from './grupo-tipo/grupo-tipo.component';
import { TipoComponent } from './tipo/tipo.component';
import { AreaComponent } from './area/area.component';
import { OrigenComponent } from './origen/origen.component';
import { SeveridadComponent } from './severidad/severidad.component';
import { ClasificacionComponent } from './clasificacion/clasificacion.component';
import { ComponenteComponent } from './componente/componente.component';
import { ReparacionesComponent } from './reparaciones/reparaciones.component';
import { AreaComponenteComponent } from './area-componente/area-componente.component';
import { CriteriosDeSimilitudComponent } from './criterios-de-similitud/criterios-de-similitud.component';
import { GestionUsuariosComponent } from './gestion-usuarios/gestion-usuarios.component';
import { LoginComponent } from './login/login.component';
import { AppComponent } from './app.component';
import { OperadoresComponent } from './operadores/operadores.component';
import { DatosUsuarioComponent } from './datos-usuario/datos-usuario.component';
import { ValorizacionComponent } from './valorizacion/valorizacion.component';
import { ClientesOperadoresComponent } from './clientes-operadores/clientes-operadores.component';
import { GestionUsuariosOperadorComponent } from './gestion-usuarios-operador/gestion-usuarios-operador.component';
import { ConsultaUsuariosOperadorComponent } from './consulta-usuarios-operador/consulta-usuarios-operador.component';
import { ModelosComponent } from './modelos/modelos.component';
import { BuquesComponent } from './buques/buques.component';
import { VinsBuquesComponent } from './vins-buques/vins-buques.component';
import { ManualesOperadoresComponent } from './manuales-operadores/manuales-operadores.component';
import { PowerBIComponent } from './Reportes/power-bi/power-bi.component';
import { ReportesInternosComponent } from './Reportes/reportes-internos/reportes-internos.component';

const routes: Routes = [
  { path: 'Home', component: HomeComponent },
  { path: 'ConsultaInspecciones', component: ConsultaInspeccionesComponent },
  { path: 'GrupoTipo', component: GrupoTipoComponent },
  { path: 'Tipo', component: TipoComponent },
  { path: 'Area', component: AreaComponent },
  { path: 'Origen', component: OrigenComponent },
  { path: 'Severidad', component: SeveridadComponent },
  { path: 'Clasificacion', component: ClasificacionComponent },
  { path: 'Componente', component: ComponenteComponent },
  { path: 'Reparaciones', component: ReparacionesComponent },
  { path: 'AreaComponente', component: AreaComponenteComponent },
  { path: 'Operadores', component: OperadoresComponent },
  { path: 'CriteriosDeSimilitud', component: CriteriosDeSimilitudComponent },
  { path: 'GestionUsuarios', component: GestionUsuariosComponent },
  { path: 'GestionUsuariosOperador', component: GestionUsuariosOperadorComponent },
  { path: 'ConsultarUsuariosOperador', component: ConsultaUsuariosOperadorComponent },
  { path: 'login', component: LoginComponent },
  //{ path: 'app', component: AppComponent },
  { path: 'Perfil', component: DatosUsuarioComponent },
  { path: 'Valorizacion', component: ValorizacionComponent },
  { path: 'ClientesOperadores', component: ClientesOperadoresComponent },
  { path: 'Modelos', component: ModelosComponent },
  { path: 'Buques', component: BuquesComponent },
  { path: 'VinsBuques', component: VinsBuquesComponent },
  { path: 'ManualesOperadores', component: ManualesOperadoresComponent },
  { path: 'PowerBI', component:  PowerBIComponent },
  { path: 'ReportesInternos', component:  ReportesInternosComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
